import Tile from "@shared/components/ui-kit/form/Tile/Tile.web";
import TileGroup from "@shared/components/ui-kit/form/TileGroup/TileGroup.web";
import Box from "@shared/components/ui-kit/layout/Box/Box.web";
import Text from "@shared/components/ui-kit/typography/Text/Text.web";
import { SHIPPING_METHODS_BY_ID } from "@shared/constants/enums";
import { ShippingMethodsTypeMapIdType } from "@shared/constants/enums/enums-types";
import { useTranslation } from "@shared/utils/internationalization";
import StatusBadge from "../../badges/StatusBadge/StatusBadge.web";

function ItemGroupDeliveryMethod({
  shippingTypes,
  handleChangeShippingType,
  isBasketUpdating,
  willCallLabel,
}: {
  shippingTypes: ShippingMethodsTypeMapIdType[];
  handleChangeShippingType: (
    shippingType: ShippingMethodsTypeMapIdType
  ) => void;
  isBasketUpdating: boolean;
  willCallLabel?: string;
}) {
  const { t } = useTranslation("checkout");

  const recommendedShippingMethods = {
    [SHIPPING_METHODS_BY_ID.st_print.id]: true,
  } as Record<ShippingMethodsTypeMapIdType, boolean>;

  const SHIPPING_METHODS_MAP = {
    ...SHIPPING_METHODS_BY_ID,
    [SHIPPING_METHODS_BY_ID.st_print.id]: {
      ...SHIPPING_METHODS_BY_ID.st_print,
      name: t("e-ticket"),
    },
    [SHIPPING_METHODS_BY_ID.st_will_call.id]: {
      ...SHIPPING_METHODS_BY_ID.st_will_call,
      name: willCallLabel ?? t("Will Call"),
    },
  };

  return (
    <Box display="flex" flexDirection="column" gap="xs">
      <Box
        display="flex"
        flexDirection="row"
        justifyContent="space-between"
        alignItems="center"
      >
        <Box>
          <Text fontWeight={600}>{t("Select delivery method")}</Text>
        </Box>
        <Box>
          <StatusBadge status="warning">{t("Selection required")}</StatusBadge>
        </Box>
      </Box>

      <Box>
        <TileGroup
          variant="single"
          onChange={(shippingType) =>
            handleChangeShippingType(
              shippingType as ShippingMethodsTypeMapIdType
            )
          }
        >
          {shippingTypes.map((shippingType) => {
            const isRecommended = recommendedShippingMethods[shippingType];

            return (
              <Tile
                key={shippingType}
                id={shippingType}
                isLoading={isBasketUpdating}
              >
                <Text color="font.dark" fontWeight={600}>
                  <Text as="span">
                    {SHIPPING_METHODS_MAP[shippingType].name}
                  </Text>{" "}
                  {isRecommended && <Text as="span">({t("recommended")})</Text>}
                </Text>
              </Tile>
            );
          })}
        </TileGroup>
      </Box>
    </Box>
  );
}

export default ItemGroupDeliveryMethod;
